import Box from '../components/Box';
import Order from '../components/Order';
import Form from '../components/Form';
import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import { RegisterOptions, useForm } from 'react-hook-form';
import {
  max,
  mistakeMailaddressMessage,
  requiredByMailaddressMessage,
} from '../../../message';
import FormBlockItem from '../../../components/common/FormBlockItem';
import {
  useGetCurrentUserQuery,
  usePostUserSendEmailChangeMailMutation,
} from '../../../api/userApi';
import HeaderLayout from '../../../components/HeaderLayout';
import { logger } from '../../../services/logger';

const emailValidation: RegisterOptions = {
  required: requiredByMailaddressMessage,
  maxLength: {
    value: 255,
    message: max('メールアドレス', 255),
  },
  validate: (value: string) => {
    return value.indexOf('@') !== -1 || mistakeMailaddressMessage;
  },
};

function ChangeEmail() {
  const email = useCurrentEmail();
  const { register, errors, onSubmit, onCancel } = useFormProps();

  return (
    <HeaderLayout title="マイページ">
      <Form onSubmit={onSubmit} onCancel={onCancel}>
        <Box title="メールアドレスを変更" isChange={true}>
          <Order>
            新しいメールアドレスを入力してください。認証URLが記載されたメールをお送りします。
          </Order>
          <FormBlockItem
            label="現在のメールアドレス"
            name="current-email"
            defaultValue={email}
            disabled
          />
          <FormBlockItem
            label="新しいメールアドレス"
            type="email"
            autoFocus
            {...register('email', emailValidation)}
            error={
              errors.email?.message ? String(errors.email?.message) : undefined
            }
          />
        </Box>
      </Form>
    </HeaderLayout>
  );
}

export default ChangeEmail;

function useCurrentEmail() {
  const { data } = useGetCurrentUserQuery();
  return data?.email;
}

function useFormProps() {
  const navigate = useNavigate();
  const [postUserSendEmailChangeMail] =
    usePostUserSendEmailChangeMailMutation();
  const methods = useForm({ mode: 'onBlur' });

  const onSubmit = methods.handleSubmit(async (data: { email?: string }) => {
    await postUserSendEmailChangeMail({ email: data.email ?? '' })
      .unwrap()
      .then(() => {
        navigate('sent-mail');
      })
      .catch(logger.error);
  });

  const onCancel = useCallback(() => {
    navigate('..');
  }, []);

  return {
    register: methods.register,
    errors: methods.formState.errors,
    onSubmit,
    onCancel,
  };
}
